import React, {useState} from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {Box, Collapse} from '@mui/material/';
import MailIcon from '@mui/icons-material/Mail';
import { HiOfficeBuilding } from "react-icons/hi";
import { ImUserTie } from "react-icons/im";
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import { TbReportMoney, TbSwitch2} from "react-icons/tb";
import { GoSettings } from "react-icons/go";
import {Link} from 'react-router-dom';
import '../App.css';
import { Help, Receipt, Dashboard, Summarize, ExpandLess, ExpandMore } from '@mui/icons-material';

const iconsList = [
  <Dashboard sx={{height: "30px", width: "30px"}} />, // 0: Dashboard
  <HiOfficeBuilding size="30px"/>, // 1: Company Master
  <ImUserTie size="30px"/>, // 2: Employee Master
  <HiOutlineCurrencyRupee size="30px"/>, // 3: Payroll
  <Receipt sx={{height: "30px", width: "30px"}} />, // 4: Income Tax
  <Summarize sx={{height: "30px", width: "30px"}} />, // 5: Reports
  <MailIcon sx={{height: "30px", width: "30px",}} />, // 6: Email
  <GoSettings size="30px"/>, // 7: Configure
  <TbSwitch2 size="30px"/>, // 8: Switch Company
  <Help sx={{height: "30px", width: "30px"}} /> // 9: Help
];

// Nested submenu item component
const NestedSubMenuItem = ({ listItem, toggleDrawer }) => {
  const [showNested, setShowNested] = useState(false);
  
  // Check if this item has nested sub-items (4th element is an array)
  const hasNestedItems = listItem.length > 3 && Array.isArray(listItem[3]);
  
  if (hasNestedItems) {
    return (
      <Box sx={{marginLeft: "35px"}}>
        <ListItem disablePadding>
          <ListItemButton onClick={() => setShowNested(!showNested)}>
            <ListItemIcon>
              {listItem[2]}
            </ListItemIcon>
            <ListItemText primary={listItem[0]} />
            {showNested ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        </ListItem>
        <Collapse in={showNested} timeout="auto" unmountOnExit>
          {listItem[3].map((nestedItem, j) => (
            <Box key={j} sx={{marginLeft: "25px"}}>
              <Link to={nestedItem[1]} className="link" onClick={toggleDrawer("left", false)}>
                <ListItem disablePadding>
                  <ListItemButton sx={{ pl: 2 }}>
                    <ListItemIcon>
                      {nestedItem[2]}
                    </ListItemIcon>
                    <ListItemText primary={nestedItem[0]} />
                  </ListItemButton>
                </ListItem>
              </Link>
            </Box>
          ))}
        </Collapse>
      </Box>
    );
  }
  
  // Regular submenu item without nesting
  return (
    <Box sx={{marginLeft: "35px"}}>
      <Link to={listItem[1]} className="link" onClick={toggleDrawer("left", false)}>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              {listItem[2]}
            </ListItemIcon>
            <ListItemText primary={listItem[0]} />
          </ListItemButton>
        </ListItem>
      </Link>
    </Box>
  );
};

const DrawerListItem = ({index, text, subList, toggleDrawer}) => {
  const [show, setShow] = useState(false);
  const [color, setColor] = useState("#344D67");

  // Check if there's a single submenu item that matches the main menu text (for direct navigation)
  const hasDirectNavigation = subList.length === 1 && subList[0][0] === text && subList[0][1] !== '';

  const handleClick = () => {
    if (hasDirectNavigation) {
      // Direct navigation - close drawer and navigate
      toggleDrawer("left", false)();
      // Navigation will be handled by the Link component
    } else {
      // Toggle submenu
      setShow(!show);
      setColor(!show ? "#C06C84" : "#344D67");
    }
  };

  return (
    <>
    <div>
      {hasDirectNavigation ? (
        <Link to={subList[0][1]} className="link" onClick={toggleDrawer("left", false)}>
          <ListItem key={text} sx={{color:{color}}} >
            <ListItemButton>
              <ListItemIcon sx={{color:{color}}}>
                {iconsList[index]}
              </ListItemIcon>
              <ListItemText primary={text}/>
            </ListItemButton>
          </ListItem>
        </Link>
      ) : (
        <>
          <ListItem key={text} onClick={handleClick} sx={{color:{color}}} >
            <ListItemButton>
              <ListItemIcon sx={{color:{color}}}>
                {iconsList[index]}
              </ListItemIcon>
              <ListItemText primary={text}/>
            </ListItemButton>
          </ListItem>
          {show && subList.length >=1 &&
            subList.map((listItem, i) => {
              if (!listItem) return null; // Skip empty/null items
              return (
                <NestedSubMenuItem 
                  key={i} 
                  listItem={listItem} 
                  toggleDrawer={toggleDrawer} 
                />
              );
            })
          }
        </>
      )}
      </div>
    </>
  )
}

export default DrawerListItem;
